import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  getExtensionRequestStatuses,
  GetExtensionRequestStatusesResponse,
  QueryDefaults,
} from 'api';

export const useExtensionRequestStatuses =
  (): QueryObserverResult<GetExtensionRequestStatusesResponse> =>
    useQuery(
      [API_QUERY_KEYS.getExtensionRequestStatuses],
      getExtensionRequestStatuses,
      QueryDefaults
    );
